import { CreateOrderPayloadServices } from "src/types/CreateOrderPayload";

export const getTotalQuantity = (
  fromSelectedServices: CreateOrderPayloadServices
) => fromSelectedServices.reduce((total, { quantity }) => total + quantity, 0);
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";